import { InputSelect } from './InputSelect';

export default InputSelect;